<div class='configuration-accelerators-tab1-part'>
	This is configuration-accelerators tab 1
</div>